import { signOut, SignOutParams } from 'next-auth/react';
import { dispatch } from '../../../events/dispatch';
import { AUTH_EVENT_TYPES } from '../../../events/constants';

export const zillowSignOut = async (options?: SignOutParams) => {
    dispatch(AUTH_EVENT_TYPES.LOGOUT);
    signOut({
        callbackUrl: '/',
        ...options,
    });
};
